import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import RemodelingServicesIntro from "./sections/RemodelingServicesIntro";
import ServicesGrid from "./sections/ServicesGrid";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <RemodelingServicesIntro />
      <ServicesGrid />
      <ClosingCta />
      <Footer />
    </div>;
}